import { useTheme } from "../../theme/useTheme"
import { Box } from "@mui/material"
import React, { type ReactNode } from "react"

interface MainContentProps {
    children: ReactNode
}

export const MainContent: React.FC<MainContentProps> = ({ children }) => {
    const { themeSettings } = useTheme()

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                // a flex item's min-width:auto floors it at the zoomed sheet's
                // intrinsic width — zero it so the column shrinks to what flex
                // allots (a 9px horizontal pan on a 320px phone otherwise)
                minWidth: 0,
                backgroundColor: themeSettings.backgroundColor,
            }}
        >
            {children}
        </Box>
    )
}
